/* eslint-disable @typescript-eslint/no-explicit-any */

import React from "react";

import {
  errorForm,
  fireNewRelicErrorEvent,
} from "@origin-digital/reporting-client";

import { ErrorPage } from "@/pages/ErrorPage";

import { addFetchInterceptor } from "../fetchInterceptor";

export class ErrorWrapper extends React.PureComponent<any, any> {
  public state = { error: null };

  public componentDidMount(): void {
    addFetchInterceptor();
  }

  public componentDidCatch(error: Error) {
    fireNewRelicErrorEvent(error);
    errorForm({
      errorCode: error.name,
      errorMessage: error.message,
    });
    this.setState({ error });
  }

  public render() {
    const { children } = this.props;

    if (this.state.error) {
      return <ErrorPage />;
    }

    return children;
  }
}
